<template>
    <div class="box-container" >
      <div class="box-image" :style="backgroundStyle"></div>
      <h1>{{ title }}</h1>
      <p class="card-text">{{ text }}</p>
    </div>

</template>
  
<script>

export default {
  name: 'TecnologiesBox',
  props: {
    title: String,
    text: String,
    bgImage: String,
  },
  computed:{
    backgroundStyle(){
      return {
        backgroundImage: `url(${this.bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    }
  }
}

</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>     
.box-container{
  width: 22em;
  height: 18em;
  border-radius: 0.8em;
  transition: transform 0.6s;
  z-index: 1;
  border: 2px solid #0e0e0e;
  background-color: #fdf9f8;
}

.box-container:hover{
  transform: scale(1.05);
  box-shadow: 0.3em 0.3em 0em 0.1em #494949;
  transition: 0.3s;

}

.box-image{
  width: 100%;
  height: 60%;
  border-radius: 0.8em 0.8em 0em 0em;
}

h1{
  font-size: 1.4em;
  margin: 0.5em;
}

.card-text{
  margin: 0.5em;
}

</style>